export const SET_COLUMN_OPTIONS = "SET_COLUMN_OPTIONS";
export const UPDATE_COLUMN_OPTION = "UPDATE_COLUMN_OPTION";
